/* Switch for the Commissioning API. If set to _Commissions, ensure the 
 * manual-commission.js Reactor script is deployed to emulate.
 */
export const COMMISSION_ACTION_TYPE = 'commissions';
